import { render, staticRenderFns } from "./CreatePostView.vue?vue&type=template&id=b12b1ce8&"
import script from "./CreatePostView.vue?vue&type=script&lang=ts&"
export * from "./CreatePostView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports